import React, { useState, useEffect } from "react";
import "../Survey/SurveyPage.css";
import activeMic from "../icons/mic-on.svg";
import copyIcon from "../icons/copy-icon.svg";
import arrowDownIcon from "../icons/arrow-down.svg";
import arrowUpIcon from "../icons/arrow-up.svg";
import inactiveMic from "../icons/mic-off.svg";
import QuestionCarousel from "../../components/Carousel/QuestionCarousel";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { contentPlanActions, postActions, questionsActions } from "../../store";
import {
  Layout, Row, Col, Card, Space, Typography, Button, Divider, Tabs, Select, Slider,
  Drawer, Empty, Alert, Avatar, Badge, notification, message, Input
} from "antd";
import {
  ThunderboltOutlined, AudioOutlined, CopyOutlined, SettingOutlined,
  ReloadOutlined, UpOutlined, DownOutlined, EyeOutlined,
  LinkedinOutlined, InstagramOutlined, FacebookOutlined, SaveOutlined
} from "@ant-design/icons";
import PageHeader from "../../components/Header/PageHeader";
import { useTranslation } from "react-i18next";
import AudioRecorder from "audio-recorder-polyfill";
import i18n from "i18next";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import {fetchWrapper} from "../../helpers";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {SETTINGS} from "../../constants/settings";

const tr = (val, lang) => typeof val === "string" ? val : (val?.[lang] ?? val?.ru ?? val?.en ?? Object.values(val ?? {})[0] ?? "");


const baseUrl = `${process.env.REACT_APP_API_URL}`;
export const CreatePost = ({ openNotification }) => {
  const [notificationApi, notificationContextHolder] =
      notification.useNotification();
  const memoizedPostFormats = JSON.parse(localStorage.getItem('postFormats')) || undefined;
  window.MediaRecorder = AudioRecorder;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const contentPlan = useSelector((obj) => obj.contentPlan.contentPlan);
  const leadingQuestionsLoading = useSelector(
    (obj) => obj.contentPlan.leadingQuestionsLoading
  );
  const postLoading = useSelector((obj) => obj.post.loading);
  const [isMicActive, setIsMicActive] = useState(false);
  const [openedLeading, setOpenedLeading] = useState(true);
  const [answer, setAnswer] = useState("");
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [postModel, setPostModel] = useState(memoizedPostFormats?.postModel || SETTINGS.POST_MODEL.DEFAULT);
  const [postLength, setPostLength] = useState(memoizedPostFormats?.postLength || SETTINGS.POST_LENGTH.DEFAULT);
  const [postEmojis, setPostEmojis] = useState(memoizedPostFormats?.postEmojis || SETTINGS.POST_EMOJIS.DEFAULT);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [contentFormats, setContentFormats] = useState([]);
  const [selectedContentFormatId, setSelectedContentFormatId] = useState(null);
  const [selectedContentLangs, setSelectedContentLangs] = useState(memoizedPostFormats?.contentLangs || []);

  const startRecording = () => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        setIsMicActive(true);
        const recorder = new MediaRecorder(stream);
        recorder.start();
        setMediaRecorder(recorder);
        recorder.addEventListener("dataavailable", (e) => {
          message.loading(t("functions.loading"));
          const audioBlob = new Blob([e.data], { type: "audio/wav" });
          const audioFile = new File([audioBlob], "recording.wav", {
            type: "audio/wav",
          });
          const formData = new FormData();
          formData.append("audio", audioFile);

          axios({
            method: "POST",
            url: `${process.env.REACT_APP_API_URL}/upload-audio`,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: formData,
          })
            .then(
              (data) =>
                data.data &&
                setAnswer((answer) => `${answer || ""}${data.data}`)
            )
            .catch((error) => console.error(error));
        });
      })
      .catch((error) => {
        message.error(t("functions.microphone"));
      });
  };

  const stopRecording = () => {
    mediaRecorder?.stop();
    // You might want to do something with the audio chunks here, like creating a blob and saving or playing it
    const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
    // Resetting audio chunks after recording is stopped
    setAudioChunks([]);
    setIsMicActive(false);
    // Here, you could save the blob or do something else with it
  };

  const handleChangeGeneratedLangs = (value) => {
    setSelectedContentLangs(value)
  }

  useEffect(() => {
    return () => {
      mediaRecorder?.state === "recording" && mediaRecorder.stop();
    };
  }, [mediaRecorder]);

  const toggleMic = () => {
    if (isMicActive) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const openNotificationEndSubscribe = () => {
    const key = `open${Date.now()}`;
    const btn = (
        <Space>
          <Button
              type="primary"
              size="small"
              onClick={() => navigate("/subscription-plans")}
          >
            {t("posts.goToRate")}
          </Button>
        </Space>
    );
    notificationApi.open({
      message: t("functions.error"),
      description: t("posts.limit"),
      btn,
      key,
    });
  };

  const submitAnswer = async () => {
    if (answer.length > 2000) {
      message.error(t("functions.maxTextLength", {limit: 2000}));
      return;
    }

    message.loading(t("functions.generatingPost"));
    const requestBody = {
      id: contentPlan.id,
      details: answer,
      formatId: selectedContentFormatId,
      selectedContentLangs: selectedContentLangs,
      postLength: postLength,
      postEmojis: postEmojis,
      postModel: postModel,
    };
    // dispatch()
    if (answer) {
      await dispatch(
        contentPlanActions.createContentPlanDetails(requestBody)
      );
    }

    await dispatch(postActions.generatePost({contentPlanId:contentPlan.id, reqBody: requestBody})).then((res) => {
      if (res.error === 'Достигнут лимит действий'){
        openNotificationEndSubscribe();
      } else {
        if (res.error) {
          openNotification();
        }
      }
    });

    // try {
    //   await dispatch(postActions.generatePost(contentPlan.id));
    // } catch {
    //   // openNotification();
    // }
  };

  const generateLeadingQuestions = () => {
    message.loading(t("functions.loadingLeading"));
    dispatch(contentPlanActions.generateLeadingQuestions(contentPlan.id));
  };

  const clipboardCopy = (text) => {
    navigator.clipboard.writeText(text);
    message.success(t("functions.copied"));
  };

  const handleRememberOptionsPublicationFormats = () => {
    const memoValues = {
      postModel: postModel,
      postLength: postLength,
      postEmojis: postEmojis,
      contentLangs: selectedContentLangs,
    };
    localStorage.setItem('postFormats', JSON.stringify(memoValues));
    message.success(t("functions.successfullySaved"));
  };

  const onChangeTextarea = (e) => {
    setAnswer(e.target.value);
    // if (
    //   i18n.language === "en" &&
    //   (new RegExp(/^[a-zA-Z0-9()*_\-!#$%^&*,.()@';:><?"^№~}{\'\+=\s\b]+$/).test(
    //     e.target.value
    //   ) ||
    //     e.target.value == "")
    // ) {
    //   setAnswer(e.target.value);
    // } else if (
    //   i18n.language === "ru" &&
    //   (new RegExp(/^[а-яА-Я0-9()*_\-!#$%^&*,.()@';:><?"^№~}{\'\+=\s\b]+$/).test(
    //     e.target.value
    //   ) ||
    //     e.target.value == "")
    // ) {
    //   setAnswer(e.target.value);
    // } else {
    //   messageApi.open({
    //     type: "error",
    //     content: t("functions.wrongLayout"),
    //   });
    // }
  };

  const onChangeFormatsCheckboxes = (e) => {
    e.stopPropagation();
    const { id } = e.target;

    if (selectedContentFormatId === id) {
      setSelectedContentFormatId(null);
    } else {
      setSelectedContentFormatId(id);
    }

  }

  useEffect(() => {
    fetchWrapper.get(`${baseUrl}/postformats`)
        .then((res) => {
          setContentFormats(res);
        });
  }, []);

  return (
      <Layout style={{ minHeight: "100vh", background: "linear-gradient(180deg, #ffffff, #faf5ff)" }}>
        {/* TOP BAR */}
        <Layout.Header
            style={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              background: "rgba(255,255,255,0.85)",
              backdropFilter: "blur(6px)",
              borderBottom: "1px solid #f0f0f0",
              paddingInline: 16,
            }}
        >
          <Row align="middle" justify="space-between" style={{ maxWidth: 1200, margin: "0 auto", width: "100%" }}>
            <Space align="center" size={12}>
              <Badge color="#7c3aed" />
              <Typography.Title level={4} style={{ margin: 0 }}>
                {t("post.headerCreate") || "Create Post"}
              </Typography.Title>
            </Space>
            <Space>
              <Button onClick={() => navigate("/home")}>{t("common.back")}</Button>
              <Button onClick={() => setDrawerVisible(true)} icon={<SettingOutlined />}>
                {t("postPage.buttons.settings") || "Settings"}
              </Button>
              <Button
                  type={isMicActive ? "primary" : "default"}
                  ghost={isMicActive}
                  onClick={toggleMic}
                  icon={<AudioOutlined />}
              >
                {isMicActive ? t("assistant.stopRecording") : t("assistant.startRecording")}
              </Button>
              <Button type="primary" icon={<ThunderboltOutlined />} loading={postLoading} onClick={submitAnswer}>
                {t("functions.generate")}
              </Button>
            </Space>
          </Row>
        </Layout.Header>

        {/* CONTENT */}
        <Layout.Content style={{ maxWidth: 1200, margin: "24px auto", width: "100%", padding: "0 16px" }}>
          {contextHolder}
          {notificationContextHolder}

          <Row gutter={[16, 16]}>
            {/* LEFT COLUMN */}
            <Col xs={24} lg={14}>
              {/* Leading Questions */}
              <Card className="shadow-sm" bodyStyle={{ padding: 16 }}>
                <Row align="middle" justify="space-between">
                  <Space size={10} align="center">
                    <QuestionCircleOutlined />
                    <Typography.Title level={5} style={{ margin: 0 }}>{t("post.leadingQuestions")}</Typography.Title>
                  </Space>
                  <Space>
                    <Button icon={<ReloadOutlined />} onClick={generateLeadingQuestions} loading={leadingQuestionsLoading}>
                      {t("postPage.buttons.refresh")}
                    </Button>
                    <Button
                        icon={openedLeading ? <UpOutlined /> : <DownOutlined />}
                        onClick={() => setOpenedLeading((v) => !v)}
                    >
                      {openedLeading ? t("postPage.buttons.hide") : t("postPage.buttons.show")}
                    </Button>
                  </Space>
                </Row>
                <Divider style={{ margin: "12px 0" }} />
                {contentPlan?.leadingQuestions ? (
                    <div>
                      <Alert
                          type="info"
                          showIcon
                          action={
                            <Button size="small" onClick={() => clipboardCopy(contentPlan.leadingQuestions)}>
                              {t("functions.copy")}
                            </Button>
                          }
                          message={
                            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{contentPlan.leadingQuestions}</pre>
                          }
                      />
                      {openedLeading && (
                          <QuestionCarousel
                              // keeps your existing carousel usage/props
                          />
                      )}
                    </div>
                ) : (
                    <Empty description={t("postPage.dropzone.noLeadingYet") || "No leading questions yet"} />
                )}
              </Card>

              {/* Answer / Details */}
              <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                <Row align="middle" justify="space-between">
                  <Typography.Title level={5} style={{ margin: 0 }}>{t("postPage.cards.detailsTitle") || "Your Notes"}</Typography.Title>
                  <Space split={<Divider type="vertical" />}>
                    <Typography.Text type="secondary">{t("postPage.cards.characters")}:</Typography.Text>
                    <Typography.Text>{answer?.length || 0}/2000</Typography.Text>
                  </Space>
                </Row>
                <Divider style={{ margin: "12px 0" }} />
                <Input.TextArea
                    value={answer}
                    onChange={onChangeTextarea}
                    placeholder={t("postPage.placeholders.detailsPlaceholder") || "Add context, links, bullet points…"}
                    autoSize={{ minRows: 8, maxRows: 14 }}
                    maxLength={2000}
                    showCount
                />
                <Space style={{ marginTop: 12 }}>
                  <Button onClick={() => setAnswer("")}>{t("postPage.buttons.clear")}</Button>
                  <Button icon={<CopyOutlined />} onClick={() => clipboardCopy(answer)} disabled={!answer}>
                    {t("postPage.buttons.copy")}
                  </Button>
                </Space>
              </Card>

              {/* Generation Options */}
              <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                <Row align="middle" justify="space-between">
                  <Typography.Title level={5} style={{ margin: 0 }}>{t("postPage.cards.generationOptions")}</Typography.Title>
                  <Button onClick={handleRememberOptionsPublicationFormats} icon={<SaveOutlined />}>
                    {t("postPage.buttons.remember")}
                  </Button>
                </Row>
                <Divider style={{ margin: "12px 0" }} />

                <Row gutter={[12, 12]}>
                  <Col xs={24} md={12}>
                    <Card size="small" bordered>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Typography.Text strong>{t("postPage.cards.formatPostTitle")}</Typography.Text>
                        <Row gutter={[8, 8]}>
                          {Array.isArray(contentFormats) && contentFormats.length ? (
                              contentFormats.map((fmt) => (
                                  <Col xs={12} key={fmt.id}>
                                    <Card
                                        size="small"
                                        hoverable
                                        onClick={(e) => {
                                          e.target.id = fmt.id; // keep your handler shape
                                          onChangeFormatsCheckboxes(e);
                                        }}
                                        bodyStyle={{
                                          padding: 10,
                                          border:
                                              String(selectedContentFormatId) === String(fmt.id)
                                                  ? "1px solid #7c3aed"
                                                  : "1px solid #f0f0f0",
                                          borderRadius: 10,
                                        }}
                                    >
                                      <Space direction="vertical" style={{ width: "100%" }}>
                                        {/*<Typography.Text strong>{fmt.name}</Typography.Text>*/}
                                        {/*<Typography.Text type="secondary" style={{ fontSize: 12 }}>*/}
                                        {/*  {fmt.description}*/}
                                        {/*</Typography.Text>*/}
                                      </Space>
                                    </Card>
                                  </Col>
                              ))
                          ) : (
                              <Col span={24}>
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                              </Col>
                          )}
                        </Row>
                      </Space>
                    </Card>
                  </Col>

                  <Col xs={24} md={12}>
                    <Card size="small" bordered>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Typography.Text strong>{t("postPage.cards.languagesPost")}</Typography.Text>
                        <Select
                            mode="multiple"
                            value={selectedContentLangs}
                            onChange={handleChangeGeneratedLangs}
                            options={[
                              { value: "ru", label: "Русский" },
                              { value: "en", label: "English" },
                              { value: "kk", label: "Қазақша" },
                            ]}
                            placeholder={t("posts.selectLanguages")}
                            style={{ width: "100%" }}
                        />
                        <Divider style={{ margin: "8px 0" }} />
                        <Typography.Text strong>{t("postPage.cards.lengthPost")}</Typography.Text>
                        <Slider
                            value={postLength}
                            onChange={setPostLength}
                            min={0}
                            max={100}
                            tooltip={{ open: false }}
                        />
                        <Typography.Text strong>{t("postPage.cards.emojisPost")}</Typography.Text>
                        <Select
                            value={postEmojis}
                            onChange={setPostEmojis}
                            style={{ width: "100%" }}
                            options={[
                              { value: "none", label: t("postPage.toolbar.emojisOptions.none") || "None" },
                              { value: "few", label: t("postPage.toolbar.emojisOptions.few") || "Few" },
                              { value: "more", label: t("postPage.toolbar.emojisOptions.more") || "More" },
                            ]}
                        />
                        <Typography.Text strong>{t("postPage.cards.modelPost")}</Typography.Text>
                        <Select
                            value={postModel}
                            onChange={setPostModel}
                            style={{ width: "100%" }}
                            options={[
                              { value: "default", label: t("postPage.toolbar.modelOptions.default") || "Default" },
                              { value: "creative", label: t("postPage.toolbar.modelOptions.creative") || "Creative" },
                              { value: "formal", label: t("postPage.toolbar.modelOptions.formal") || "Formal" },
                            ]}
                        />
                      </Space>
                    </Card>
                  </Col>
                </Row>
              </Card>
            </Col>

            {/* RIGHT COLUMN */}
            <Col xs={24} lg={10}>
              {/* Preview */}
              <Card className="shadow-sm" bodyStyle={{ padding: 16 }}>
                <Space align="center" size={8} style={{ marginBottom: 8 }}>
                  <EyeOutlined />
                  <Typography.Title level={5} style={{ margin: 0 }}>Live Preview</Typography.Title>
                </Space>
                <Divider style={{ margin: "12px 0" }} />

                <Tabs defaultActiveKey="linkedin">
                  <Tabs.TabPane tab={<Space><LinkedinOutlined />LinkedIn</Space>} key="linkedin">
                    <Card size="small" bordered>
                      <Space align="center" size={8} style={{ marginBottom: 12 }}>
                        <Avatar size={32} style={{ background: "#1677ff" }}>IN</Avatar>
                        <Space direction="vertical" size={0}>
                          <Typography.Text strong>Company Page</Typography.Text>
                          <Typography.Text type="secondary" style={{ fontSize: 12 }}>{t("common.now")}</Typography.Text>
                        </Space>
                      </Space>
                      <Typography.Paragraph type="secondary">
                        {answer?.length ? answer.slice(0, 220) + (answer.length > 220 ? "…" : "") : t("postPage.hint.previewHint")}
                      </Typography.Paragraph>
                    </Card>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab={<Space><InstagramOutlined />Instagram</Space>} key="instagram">
                    <Card size="small" bordered>
                      <div style={{ aspectRatio: "1/1", width: "100%", background: "#f0f0f0", borderRadius: 12 }} />
                      <div style={{ height: 8, width: "60%", background: "#f0f0f0", borderRadius: 6, marginTop: 12 }} />
                      <div style={{ height: 8, width: "40%", background: "#f0f0f0", borderRadius: 6, marginTop: 8 }} />
                    </Card>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab={<Space><FacebookOutlined />Facebook</Space>} key="facebook">
                    <Card size="small" bordered>
                      <Space align="center" size={8} style={{ marginBottom: 12 }}>
                        <Avatar size={32} style={{ background: "#1677ff" }}>FB</Avatar>
                        <Space direction="vertical" size={0}>
                          <Typography.Text strong>Business Page</Typography.Text>
                          <Typography.Text type="secondary" style={{ fontSize: 12 }}>{t("common.now")}</Typography.Text>
                        </Space>
                      </Space>
                      <div style={{ height: 8, width: "100%", background: "#f0f0f0", borderRadius: 6 }} />
                      <div style={{ height: 8, width: "80%", background: "#f0f0f0", borderRadius: 6, marginTop: 8 }} />
                    </Card>
                  </Tabs.TabPane>
                </Tabs>
              </Card>

              {/* Tips */}
              <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                <Space direction="vertical" style={{ width: "100%" }} size={12}>
                  <Typography.Title level={5} style={{ margin: 0 }}>{t("postPage.cards.tipsTitle") || "Tips"}</Typography.Title>
                  <Space align="center" size={8} style={{ color: "#8c8c8c" }}>
                    <QuestionCircleOutlined /> {t("assistant.shortcutSend") || "Send: Ctrl+Enter"}
                  </Space>
                  <Space align="center" size={8} style={{ color: "#8c8c8c" }}>
                    <QuestionCircleOutlined /> {t("assistant.shortcutPaste") || "Paste: Ctrl+V"}
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  <Space>
                    <Button onClick={() => setDrawerVisible(true)}>{t("postPage.buttons.settings")}</Button>
                    <Button type="primary" icon={<ThunderboltOutlined />} loading={postLoading} onClick={submitAnswer}>
                      {t("functions.generate")}
                    </Button>
                  </Space>
                </Space>
              </Card>
            </Col>
          </Row>

          {/* Settings Drawer (uses your existing state; content optional) */}
          <Drawer
              title={t("postPage.buttons.settings")}
              open={drawerVisible}
              onClose={() => setDrawerVisible(false)}
              width={420}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <Typography.Text type="secondary">
                {t("post.settingsHint") || "Tune languages, length, emojis, and format before generating."}
              </Typography.Text>
              {/* You can drop additional controls here reusing the same handlers */}
            </Space>
          </Drawer>
        </Layout.Content>

        {/* BOTTOM BAR */}
        <Layout.Footer
            style={{
              position: "sticky",
              bottom: 0,
              zIndex: 19,
              background: "rgba(255,255,255,0.9)",
              backdropFilter: "blur(6px)",
              width: "100%",
              borderTop: "1px solid #f0f0f0",
              padding: "8px 0",
            }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 16px" }}>
            <Row align="middle" justify="space-between">
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {t("contentPlan.statusDraftSaved", { when: t("common.aMinuteAgo") })} • {t("contentPlan.autoSaveOn")}
              </Typography.Text>
              <Space>
                <Button onClick={() => navigate("/home")}>{t("common.back")}</Button>
                <Button onClick={() => setDrawerVisible(true)}>{t("postPage.buttons.settings")}</Button>
                <Button type="primary" icon={<ThunderboltOutlined />} loading={postLoading} onClick={submitAnswer}>
                  {t("postPage.buttons.generate")}
                </Button>
              </Space>
            </Row>
          </div>
        </Layout.Footer>
      </Layout>
  );

};
